interface EvoLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  iconOnly?: boolean;
}

const HEIGHT: Record<NonNullable<EvoLogoProps['size']>, string> = {
  sm: '20px',
  md: '34px',
  lg: '40px',
};

export function EvoLogo({ className = '', size = 'md', iconOnly = false }: EvoLogoProps) {
  return (
    <img
      src={iconOnly ? '/logos/evohub-icon.svg' : '/logos/evohub-logo.svg'}
      alt="Evo Hub"
      style={{ height: HEIGHT[size], width: 'auto', display: 'block' }}
      className={className}
    />
  );
}
